<template>
    <div class="main-container">
        <div class="row py-3 mx-0">
            <div 
                class="col-md-9 col-sm-6 d-flex justify-content-start"
                :class="{
                    'flex-column' : $breakpoint.smAndDown,
                    'order-2' : $breakpoint.xsOnly
                }"
            > 
                <label for="start-time" class="mr-2 mt-2">Offers available from <em>(24hr format)</em></label>
                <div 
                    class="d-flex flex-column">
                    <div class="d-flex justify-content-start flex-row flex-wrap">
                        <input 
                            class="pick-time-input" 
                            id="start-time"
                            :style="[ $breakpoint.xsOnly ? {width: 'calc(50% - 20px)'} : {} ]"
                            type="time" Min="1:00" Max="24:00" placeholder="--:--" v-model="startTime">
                        <strong class="mx-2 mt-2">to</strong>
                        <input 
                            class="pick-time-input mr-2" 
                            :style="[ $breakpoint.xsOnly ? {width: 'calc(50% - 20px)'} : {} ]"
                            type="time" Min="1:00" Max="24:00" placeholder="--:--" v-model="endTime">
                        <button 
                            class="btn btn-actionable time-availability" 
                            :class="[$breakpoint.smAndDown ? 'mt-2' : 'ml-2']"
                            @click="confirmTimeAvailability" :disabled="invalidTimesFound">Confirm availability</button>
                    </div>
                    <span v-if="invalidTimesFound" class="error-message mt-2">
                    {{invalidTimesFound}}
                </span>
                </div>
            </div>
            <div 
                class="col-md-3 col-sm-4 offset-sm-2 offset-md-0"
                :class="[{'mb-2 order-1' : $breakpoint.xsOnly}, {'d-flex justify-content-end': $breakpoint.lgAndUp}]"
            >
                <button @click="$store.dispatch('livePrices/editSettlementPrices')" class="btn btn-actionable" :class="$breakpoint.mdAndDown ? 'my-1' : 'mr-2'">
                    {{ settlementPricesButtonText }}
                </button>
                <button class="btn btn-confirm" :disabled="!(getPrices.length > 0)" @click="openContractModal()">Create Offer</button>
            </div>
        </div>
        <div class="row pb-3 mx-0">
            <div 
                class="col-md-10 col-sm-6 d-flex justify-content-start"
                :class="{
                    'flex-column' : $breakpoint.smAndDown,
                    'order-2' : $breakpoint.xsOnly
                }"
            >
            <div class="list-filter__row--input-group">
                <div class="search-wrapper w-100">
                    &nbsp;
                    <i class="fas fa-search fa-lg"></i>
                    <input
                      :class="{'mr-2' : !$breakpoint.xsOnly}"
                      v-model="filterString"
                      type="text" placeholder="Search Contracts"
                      style="border-color:#e6e6e6;"
                    >
                </div>
            </div>
            </div>
        </div>
        <div class="d-flex px-3 justify-content-between">
            <h1 class="first-header heading-medium"><i class="fas fa-chart-line mr-2"></i>My Contracts</h1>
            <div class="d-flex">
                <strong>Show All My Offers</strong>
                <label class="switch selected">
                    <input type="checkbox" class="on-off-toggler" v-model="offersAvailabilityStatus" 
                        @click="switchOffersStatus()" :disabled="disabledAllOffers || (getPrices.length < 1)">
                    <span class="slider round lg" :class="{ disabledtoggle:disabledAllOffers === true}"></span>
                </label>
                <strong>{{offersAvailabilityStatus ? 'On' : 'Off'}}</strong>
            </div>
        </div>

        <div v-if="getPrices.length < 1" class="row disabled bg-white mx-0 pt-3 pb-3">
            <div class="col-md-12 px-0">
                <div class="alert tables-alert-custom-message-notify mt-3 text-center">
                    <i class="fas fa-info-circle mr-2"></i>
                    Offers will not be displayed to buyers until Settlement Prices have been updated. Click on {{ settlementPricesButtonText }} to update Settlement Prices
                </div>
            </div>
        </div>
        <div class="row mx-0">
            <div 
                class="col-md-12"
                :class="{'px-0' : !$breakpoint.mdAndDown}"
            >
                <div class="table-container">
                    <div v-if="allContracts.length < 1 && filterString !== ''"
                        class="w-100 alert tables-alert-custom-message-notify mt-3 text-center">
                        <i class="fas fa-info-circle mr-2"></i>
                        Unfortunately we could not find any results that match the search
                    </div>
                    <div v-else-if="allContracts.length < 1"
                        class="w-100 alert tables-alert-custom-message-notify mt-3 text-center">
                        <i class="fas fa-info-circle mr-2"></i>
                        You have not created any offers for this market
                    </div>
                    <table v-else id="offer_table" class="table responsive-table">
                        <thead>
                            <tr>
                                <th v-for="(item,key) in tableTitles" :key="key">
                                    {{item.title}}
                                    <i 
                                        v-if="item.sortKey === 'premium' && isPricingEngineEnabled"
                                        class="fas fa-info-circle fa-lg ml-2"
                                        data-toggle="tooltip" 
                                        data-placement="bottom" 
                                        title="Premium (ppl) is equal to the sum of all entered Cost Addition, Bio and Temperature Rules for each offer. This does not include any additional Customer Margins."
                                    ></i>
                                    <span v-if="item.sortKey === 'buyer' || 
                                                item.sortKey === 'fuel' || 
                                                item.sortKey === 'terminal' || 
                                                item.sortKey === 'bio_pricing' || 
                                                item.sortKey === 'pricing_method' ||
                                                item.sortKey === 'contract_end'">
                                        <i v-if="activeSortColumn === item.sortKey && activeSortDirection === 'asc'" 
                                            class="fas fa-sort-alpha-down sort-icon" :class="{'selected': activeSortColumn === item.sortKey && activeSortDirection === 'asc'}" 
                                            size="lg" @click="sortColumn(item.sortKey, 'desc')"></i>
                                        <i v-else class="fas sort-icon" 
                                            :class="activeSortColumn === item.sortKey && activeSortDirection === 'desc'? ['selected','fa-sort-alpha-up'] : 'fa-sort-alpha-down' " 
                                            size="lg" @click="sortColumn(item.sortKey, 'asc')"></i>
                                    </span>
                                    <span v-else-if="item.sortKey">
                                        <i v-if="activeSortColumn === item.sortKey && activeSortDirection === 'asc'" 
                                            class="fas fa-sort-numeric-down sort-icon" :class="{'selected': activeSortColumn === item.sortKey && activeSortDirection=== 'asc'}" 
                                            size="lg" @click="sortColumn(item.sortKey, 'desc')"></i>
                                        <i v-else class="fas sort-icon" 
                                            :class="activeSortColumn === item.sortKey && activeSortDirection === 'desc'? ['selected','fa-sort-numeric-up'] : 'fa-sort-numeric-down' " 
                                            size="lg" @click="sortColumn(item.sortKey, 'asc')"></i>  
                                    </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr :label="tableTitles[key]" v-for="(offer, key) in allContracts"
                                :key="key" class="offer-rows" 
                                :class="{
                                    'disabled': getPrices.length < 1,
                                    'pt-2 pb-4': $breakpoint.mdAndDown
                                }" 
                            >
                                <td >{{offer.contract.buyer.name}}</td>
                                <td label="Product">
                                    <span v-if="offer.storage_type_id == 'SPOT'">{{offer.fuel_id | fueltype}}</span>
                                    <span v-else>Network</span>
                                </td>
                                <td label="Measurement">
                                    <span>{{ offer.fuel_measurement_id | fuelmeasurementtype }}</span>
                                </td>
                                <td label="Terminal">
                                    <span v-if="offer.storage_type_id == 'SPOT'">{{offer.terminal_id |terminalsname}}</span>
                                    <span v-else>{{ getNetworkName(offer.networkId) }}</span>
                                </td>
                                <td label="Vol Remaining/L">
                                    <span v-if="offer.contract.frequency_quantity && offer.contract.frequency_quantity.length > 0">{{offer.contract.frequency_quantity | currentMonthMaximumAvailable}}</span>
                                    <span v-else>{{offer.maximumAvailable | formatNumber }}</span>
                                </td>
                                <td label="Current Month Vol/L">
                                    <span v-if="offer.contract && offer.contract.frequency_quantity">{{ offer.contract.frequency_quantity | currentMonthTotal }}</span>
                                    <span v-else>N/A</span>
                                </td>
                                <td label="Contract End">
                                    <span>{{offer.contract.end | dateformat}}</span>
                                </td>
                                <td label="Bio Pricing">
                                    <span>{{offer.fuel_id | offerbiopricing}}</span>
                                </td>
                                <td label="Pricing Method">
                                    <span>{{offer.type_id | offertype}}</span>
                                </td>
                                <td label="Lifting Period">
                                    <span>{{offer | liftingperiodformat}}</span>
                                </td>
                                <td label="Payment Terms">
                                    <span v-if="offer.contract.buyer.credit">{{offer.contract.buyer.credit.days | creditdaysformat}}</span>
                                    <span v-else>N/A</span>
                                </td>
                                <td label="Premium (ppl)">
                                    <span v-if="offer.type_id == 'FIXED'">&mdash;</span>
                                    <span v-else>{{ offer.premium | priceformat }}</span>
                                </td>
                                <td label="Price (ppl)">
                                    <span v-if="getPrices.length == 0 && offer.type_id !== 'FIXED'">N/A</span>
                                    <span v-else>{{ offer.price | priceformat }}</span>
                                    <i 
                                        v-if="getPrices.length > 0 && offer.type_id === 'TRACKING'" 
                                        class="fas fa-sm fa-rss ml-2"
                                        :class="toggleStates[key] && !isToggleDisabled(offer) ? 'tracking-active-icon-color' : 'tracking-inactive-icon-color'"
                                        data-toggle="tooltip" data-placement="bottom" 
                                        title="This Offer Price updates every 30 seconds"
                                    ></i>
                                </td>
                                <td class="td-actions">
                                    <button
                                        class="btn btn-icon btn-icon-color td-sticky td-left-bottom"
                                        :class="{'pt-3' : $breakpoint.mdAndDown}" 
                                        :disabled="getPrices.length < 1" 
                                        @click="assignOfferToDuplicate(offer._id)">
                                        <i class="fas fa-clone fa-lg"></i>
                                    </button>
                                </td>
                                <td class="td-actions">
                                    <button
                                        class="btn btn-icon btn-icon-color td-sticky td-center-left-bottom"
                                        :class="{'pt-3' : $breakpoint.mdAndDown}"
                                        @click="editOfferMethod(offer._id)">
                                        <i class="fas fa-edit fa-lg"></i>
                                    </button>
                                </td>
                                <td class="td-actions">
                                    <div class="pt-2" v-if="$breakpoint.mdAndDown"></div>
                                    <span class="switch-value"></span>
                                    <label class="switch selected td-sticky td-center-right-bottom">
                                        <input type="checkbox" class="on-off-toggler" v-model="toggleStates[key]" @click="switchSingleToggle(offer)" 
                                                :disabled="isToggleDisabled(offer)" :key="offer._id">
                                        <span class="slider round"></span>
                                    </label>
                                </td>
                                <td class="td-actions">
                                    <button 
                                        class="btn btn-icon td-sticky td-right-bottom" 
                                        :class="{'pt-3' : $breakpoint.mdAndDown}"
                                        @click="removeOffer(offer)">
                                            <i class="fas fa-trash-alt fa-lg" ></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import {mapGetters, mapActions, mapState} from 'vuex'
import breakpoint from '@/mixins/index';
import { hasContractRemainingQuantity, _isDateWithinContractAvailability } from '@/util/contracts.js';
import { _checkOffersAvailabilityHours } from '@/util/offers.js';

export default {
    mixins: [breakpoint],
    data:function(){
        return{
            tableTitles:[
                {title: 'Buyer', sortKey: 'buyer'},
                {title: 'Product', sortKey: 'fuel'},
                {title: 'Measurement', sortKey: 'fuel_measurement_id'},
                {title: 'Terminal', sortKey: 'terminal'},
                {title: 'Vol Remaining/L', sortKey: 'volume_remaining'},
                {title: 'Current Month Vol/L', sortKey: 'current_month_total'},
                {title: 'Contract End', sortKey: 'contract_end'},
                {title: 'Bio Pricing', sortKey: 'bio_pricing'},
                {title: 'Pricing Method', sortKey: 'pricing_method'},
                {title: 'Lifting Period', sortKey: 'collection_days'},
                {title: 'Payment Terms', sortKey: 'credit_days'},
                {title: 'Premium (ppl)', sortKey: 'premium'},
                {title: 'Price (ppl)', sortKey: 'price'},
                {title: "Duplicate"},
                {title: 'Edit'},
                {title: 'Off/On'},
                {title: 'Remove'}
            ],
            activeSortColumn: '',
            activeSortDirection: '',
            startTime: '',
            endTime: '',
            offersAvailabilityStatusProxy: null,
            filterString: ''
        }
    },
    created(){
        this.setAvailabilityDetails();
    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
    computed:{
        ...mapGetters('livePrices',['getPrices', 'getPricesUpdate', 'settlementPricesButtonText']),
        ...mapGetters('login', ['isPricingEngineEnabled']),
        ...mapGetters('sellerOffers',['liveOffersSeller']),
        ...mapGetters('metadata', ['networkConfig', 'networks']),
        ...mapGetters('accounts', ['customerList']),
        ...mapGetters('metadata', ['networks']),
        ...mapState('itemRemoval', ['showItemRemovalConfirmation']),
        ...mapState('sellerOffers',['showContractModal', 'newOfferBeenAdded', 'editWasSuccess','offersAvailability']),
        ...mapState('login',['userLoggedIn']),

        allContracts: {
            get: function(){
                let offers = [];
                if (this.liveOffersSeller && this.liveOffersSeller.length > 0 && this.customerList && this.customerList.length > 0) {
                    offers = this.liveOffersSeller.filter(offer => offer.isContract && (offer.storage_type_id == 'SPOT' || 'BUNKERING') && this.searchOffers(offer));
                }
                this.activeSortColumn = '';
                this.activeSortDirection = '';
                return offers;
            }
        },
        offersAvailabilityStatus: {
            get: function(){
                if (this.offersAvailability){
                    if(this.offersAvailability.contracts.spot.enabled && this.offersAvailability.contracts.bunkering.enabled)
                        return true;
                    else
                        return false;
                }else{
                    return false;
                }
            },
            set: function(newValue){ // Only purpose this serves is an issue with using a computed property with v-model (requires a setter)
                this.offersAvailabilityStatusProxy = newValue; 
            }
        },
        toggleStates: {
            get: function(){
                let state = [];

                if (this.allContracts){
                    this.allContracts.forEach(offer => {
                        if (offer.status_type_id === 'ACTIVE'){
                            state.push(true)
                        } else {
                            state.push(false)
                        }
                    })
                }
                return state
            }
        },
        disabledAllOffers: {
            get: function(){
                let disabledStatus = false;
                
                if (this.offersAvailability){
                    disabledStatus = !_checkOffersAvailabilityHours(this.offersAvailability.contracts.spot.start, this.offersAvailability.contracts.spot.end);
                }

                return disabledStatus;
            }
        },
        invalidTimesFound: {
            get: function(){
                const re = /^([01][0-9]|2[0-3]):([0-5][0-9])$/
                
                if (this.startTime && this.endTime){
                    if(!this.startTime.match(re) || !this.endTime.match(re)){
                        return "Please enter a valid time format";
                    }else if (new Date().setHours(this.endTime.substring(0, 2), this.endTime.substring(3)) <= 
                        new Date().setHours(this.startTime.substring(0, 2), this.startTime.substring(3))){
                            return "Closing time must be later than opening time";
                    }
                } else {
                    return  "Please enter a valid time range";
                }
            }
        },
        triggerOfferModal(){
            if(this.showContractModal){
                let element = this.$root.$refs.offerModal.$el;          
                $(element).modal({backdrop: 'static', keyboard: false});
            }
            return;
        },
        triggerItemRemovalModal(){
            if(this.showItemRemovalConfirmation){
                let element = this.$root.$refs.confirmationRemoveItem.$el;
                $(element).modal({backdrop: 'static', keyboard: false});
            }
            return;
        }
    },
    watch: {
        triggerOfferModal(){},
        triggerItemRemovalModal(){}
    },
    methods:{
        ...mapActions('itemRemoval', ['openConfirmationRemoval']),
        ...mapActions('sellerOffers',['getAllOffersForUser', 'openContractModal','editOffer', 'setOffersTimeAvailability', 
            'toggleOffersAvailability','resetSuccessEditing','switchNewOffersToFalse', "duplicateOffer"]),

        sortColumn: function(sortKey, direction){
            let stringA = ''
            let stringB = ''

            this.activeSortDirection = direction;
            this.activeSortColumn = sortKey;

            const listToSort = this.allContracts;
            
            switch (sortKey){
                case 'buyer': // Sort by buyer
                    return listToSort.sort((a, b) => {
                        stringA = a.contract.buyer.name.toLowerCase()
                        stringB = b.contract.buyer.name.toLowerCase()
                        
                        if (direction === 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 'fuel': // Sort by fuel type
                    return listToSort.sort((a, b) => {
                        stringA = a.storage_type_id === 'SPOT' ? this.$root.$options.filters.fueltype(a.fuel_id) : this.getNetworkName(a.networkId);
                        stringB = b.storage_type_id === 'SPOT' ? this.$root.$options.filters.fueltype(b.fuel_id) : this.getNetworkName(b.networkId);
                        
                        if (direction === 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 'terminal': // Sort by terminal
                    return listToSort.sort((a, b) => {
                        stringA = a.storage_type_id === 'SPOT' ? a.terminal.name.toLowerCase() : this.getNetworkName(a.networkId);
                        stringB = b.storage_type_id === 'SPOT' ? b.terminal.name.toLowerCase() : this.getNetworkName(b.networkId);
                        
                        if (direction === 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 'volume_remaining': // Sort by volume remaining
                    return listToSort.sort((a, b) => {
                        stringA = a.maximumAvailable - a.contract.orderedQuantity
                        stringB = b.maximumAvailable - b.contract.orderedQuantity

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'current_month_total': // Sort by current month total
                    return listToSort.sort((a, b) => {
                        stringA = a.contract.frequency_quantity[0].quantity
                        stringB = b.contract.frequency_quantity[0].quantity

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'volume_total': // Sort by total volume
                    return listToSort.sort((a, b) => {
                        stringA = a.maximumAvailable
                        stringB = b.maximumAvailable

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'bio_pricing': // Sort by bio pricing
                    return listToSort.sort((a, b) => {
                        stringA = this.$root.$options.filters.offerbiopricing(a.fuel_id)
                        stringB = this.$root.$options.filters.offerbiopricing(b.fuel_id)
                        
                        if (direction === 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 'pricing_method': // Sort by pricing method
                    return listToSort.sort((a, b) => {
                        stringA = this.$root.$options.filters.offertype(a.type_id)
                        stringB = this.$root.$options.filters.offertype(b.type_id)
                        
                        if (direction === 'asc'){
                            if (stringA < stringB) {return -1;}
                            if (stringA > stringB) {return 1;}
                            return 0;
                        }
                        else {
                            if (stringA < stringB) {return 1;}
                            if (stringA > stringB) {return -1;}
                            return 0;
                        }
                    })
                case 'collection_days': // Sort by Lifting Period
                    return listToSort.sort((a, b) => {
                        stringA = a.collectionTime
                        stringB = b.collectionTime

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'credit_days': // Sort by credit days
                    return listToSort.sort((a, b) => {
                        stringA = a.contract.buyer.credit ? a.contract.buyer.credit.days : 100
                        stringB = b.contract.buyer.credit ? b.contract.buyer.credit.days : 100

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'premium': // Sort by premium
                    return listToSort.sort((a, b) => {
                        stringA = a.type_id === 'FIXED' ? -10000000 : a.price
                        stringB = b.type_id === 'FIXED' ? -10000000 : b.price

                        if (direction == 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'price': // Sort by price
                    return listToSort.sort((a, b) => {
                        stringA = a.type_id === 'FIXED' ? a.price : a.livePrice
                        stringB = b.type_id === 'FIXED' ? b.price : b.livePrice

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                case 'contract_end': // Sort by date
                    return listToSort.sort((a, b) => {
                        stringA = a.contract.end ? moment(a.contract.end) : moment();
                        stringB = b.contract.end ? moment(b.contract.end) : moment();

                        if (direction === 'asc'){
                            return stringA - stringB
                        }
                        else {
                            return stringB - stringA
                        }
                    })
                default:
                    return
            }
        },
        switchSingleToggle: async function(offer){
            let offerToggled = offer;
            const editTo = offerToggled.status_type_id === 'ACTIVE' ? 'PAUSED' : 'ACTIVE'
            const response = await this.axios.put('/api/editOffer',{ params: {
                offerId: offerToggled._id,
                userId: this.userLoggedIn.userId,
                statusTypeId: editTo
            }})
            if(response.data.success){
                this.getAllOffersForUser()
            }
            else {
                console.log('Error found', response)
            }
        },
        assignOfferToDuplicate: function(offerId){
            const payload = {
                offerId: offerId,
                offerType: "CONTRACT"
            };

            this.duplicateOffer(payload);
        },
        editOfferMethod: function(offerId){
            const payload = {
                offerId: offerId,
                offerType: "CONTRACT"
            };

            this.editOffer(payload);
        },
        setAvailabilityDetails: function(){
            this.startTime = this.offersAvailability.contracts.spot.start
            this.endTime = this.offersAvailability.contracts.spot.end
        },
        switchOffersStatus: function(index){
            const contractType = index == 0 ? 'SPOT' : 'BUNKERING';
            const payload = {
                type: 'CONTRACTS',
                newStatus: !this.offersAvailability.contracts[contractType.toLowerCase()].enabled
            }
            this.toggleOffersAvailability(payload)
        },
        confirmTimeAvailability: function(){
            const payload = {
                type: 'CONTRACTS',
                newStartTime: this.startTime,
                newEndTime: this.endTime
            }
            this.setOffersTimeAvailability(payload)
        },
        removeOffer: function(offer){
            const payload = {
                item: offer,
                type: "OFFER",
                showWindow: true
            };
            this.openConfirmationRemoval(payload);
        },
        isToggleDisabled: function(offer) {
            if ((offer.terminal && offer.terminal.status && offer.terminal.status !== '100')    // Is terminal valid?
                || this.disabledAllOffers   // Is the master toggle switched off?
                || this.getPrices.length < 1    // Have sellers entered daily settlement prices?
                || !this.offersAvailabilityStatus   // Is contracts enabled for this seller?
                || offer.minimumOrderQuantity > offer.maximumAvailable  // Is there still enough volume to buy this offer?
                || !_isDateWithinContractAvailability(offer.contract.end, offer.contract.start)   // Is the contract still valid?
                || !hasContractRemainingQuantity(offer.contract.frequency_quantity, offer.minimumOrderQuantity))
            {
                return true;
            }

            return false;
        },
        getNetworkName: function(networkId) {
          return this.networks.find(n => n._id === networkId).name
        },
        searchOffers: function(offer){
          const substring = this.filterString.toLowerCase();
          let fuelBool, terminalBool;

          if(offer.storage_type_id === 'SPOT') {
            fuelBool = this.$root.$options.filters.fueltype(offer.fuel_id).toLowerCase().includes(substring);
            terminalBool = this.$root.$options.filters.terminalsname(offer.terminal_id).toLowerCase().includes(substring);
          } else {
            fuelBool = "network".includes(substring)
            terminalBool = this.getNetworkName(offer.networkId).toLowerCase().includes(substring);
          }

          return offer.contract.buyer.name.toLowerCase().includes(substring)
            || offer.contract.reference.toLowerCase().includes(substring)
            || fuelBool
            || terminalBool;
        }
    }
}

</script>
